import { useContext, useState } from "react";
import { styled, Toolbar } from "@mui/material";

import { useUrlSearch } from "hooks/filterHooks";

import TagToggleButton from "./tag/TagToggleButton";
import { SearchBox } from "./search/SearchBox";
import { SortSelection } from "./sort/SortSelection";
import TagSection from "./tag/TagSection";
import ResetFilterButton from "./ResetFilterButton";
import { TextFieldContext } from "context/TextFieldContext";

export default function HeaderFilter() {
  const [toggleTagSection, setToggleTagSection] = useState<boolean>(false);
  const { search, updateSearch } = useUrlSearch();
  const { textFieldRef } = useContext(TextFieldContext);

  return (
    <>
      <StyledToolbar data-tour="step-3">
        <TagToggleButton
          isActive={toggleTagSection}
          onClick={() => setToggleTagSection(!toggleTagSection)}
          />
        <ResetFilterButton
          inputRef={textFieldRef}
          className="align-left"
          onClick={() => setToggleTagSection(!toggleTagSection)}
          search={search}
        />

        <SortSelection />
        <SearchBox
          ref={textFieldRef}
          search={search}
          updateSearch={updateSearch}
        />
      </StyledToolbar>
      {toggleTagSection && <TagSection />}
    </>
  );
}

const StyledToolbar = styled(Toolbar)`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  .align-left {
    margin-right: auto;
  }
`;
